import React from 'react';

import { useMessageStyles } from './Message.styled';

export const MessageSkeleton = () => {
  const classes = useMessageStyles();
  return (
    <div className={classes.animatedLoaderContainer}>
      <div className={classes.dot} />
      <div className={classes.dot} />
      <div className={classes.dot} />
    </div>
  );
};
